import crudAction from './actions'

export default {
  name: 'propertyScore',
  namespace: 'property_score',
  methods: [
    ...crudAction,
  ]
}
